import { render } from "./Comments.vue?vue&type=template&id=07c2e0a2&scoped=true&ts=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=07c2e0a2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c2e0a2"]])

export default __exports__